module.exports = __webpack_public_path__ + "static/img/backlog1.ad9a245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/backlog1.png
// module id = BAii
// module chunks = 83